/**
 * Route guard — redirects to /login if not authenticated.
 */

import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth-context.tsx";

export function ProtectedRoute() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
